import React from 'react';
import { Link } from 'react-router-dom';
import LifecycleDiagram from './LifecycleDiagram';

/** Membership split (reverse row) — source: mockup L387–473. */
const MembershipSplit = (): React.JSX.Element => (
  <section className="oq-membership">
    <div className="oq-container oq-membership__inner">
      <div className="oq-membership__row">
        <div className="oq-membership__copy">
          <div className="oq-membership__kicker oq-bebas">MEMBERSHIP MANAGEMENT SYSTEM</div>
          <h2 className="oq-membership__title oq-bebas">
            The whole membership lifecycle, handled
          </h2>
          <p className="oq-membership__subtitle">
            From a trial session to a seven-year member, Olympiq tracks every stage — and quietly
            chases the renewals so your treasurer doesn&apos;t have to.
          </p>
          <div className="oq-membership__bullets">
            <div className="oq-membership__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Trials &amp; tiers</b> — the app handles trial periods for you, and assigns
                privileged roles and access to coaches &amp; admins.
              </span>
            </div>
            <div className="oq-membership__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Automatic renewals</b> — reminders for subs due, with one-tap payment.
              </span>
            </div>
            <div className="oq-membership__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" />
              <span>
                <b>Clear membership reports</b> — how many are up for renewal, expiring soon, or
                lapsed, with historic membership numbers at a glance.
              </span>
            </div>
          </div>
          <Link to="/help-centre" className="oq-membership__link">
            Membership lifecycle guide <i className="mdi mdi-arrow-right" aria-hidden="true" />
          </Link>
        </div>

        <div className="oq-membership__diagram">
          <LifecycleDiagram />
        </div>
      </div>
    </div>
  </section>
);

export default MembershipSplit;
